// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

/**
 * Landing v2 — slow ingredient marquee between hero and value strip.
 * Pure-CSS translate loop (GPU, pausable on hover, disabled entirely for
 * reduced motion). Content is decorative brand texture, aria-hidden.
 */

import { DishArt, type Dish } from "./DishArt"

const STRIP: Array<{ dish: Dish; label: string }> = [
  { dish: "buddha", label: "Bowls" },
  { dish: "salmon", label: "Fisch · Fish" },
  { dish: "oats", label: "Frühstück · Breakfast" },
  { dish: "curry", label: "Curry" },
  { dish: "salad", label: "Salate · Salads" },
  { dish: "pasta", label: "Pasta" },
]

export function IngredientMarquee() {
  const items = [...STRIP, ...STRIP] // duplicated for the seamless -50% loop
  return (
    <div
      aria-hidden="true"
      className="bbv2-marquee overflow-hidden border-b border-line bg-paper py-4"
    >
      <div className="bbv2-marquee-track flex w-max items-center gap-10 px-6">
        {items.map((it, i) => (
          <span key={i} className="flex items-center gap-3 whitespace-nowrap">
            <DishArt dish={it.dish} size={40} />
            <span className="font-display text-sm font-semibold tracking-wide text-ink-2">
              {it.label}
            </span>
            <span className="mx-2 size-1.5 rounded-full bg-lime" />
          </span>
        ))}
      </div>
    </div>
  )
}
